<input 
[(ngModel)]="datesetting" 
[attr.readonly]="isReadOnly" 
autocomplete="off" 
class="form-control datepickerinput" 
name="datesetting" 
bsDatepicker
[bsConfig]="dpConfig"
(onShown)="onOpenCalendar($event)"
(ngModelChange)="changeDate($event)"
(click)="onClickInput($event)"
>